import { Link as GatsbyLink } from "gatsby"
import styled from "@emotion/styled"
import { css } from '@emotion/react'

export const color = ({ color }) => {
  if (color === "red") {
    return css({
      color: "var(--color-destruction-500)",

      "&:hover": {
        color: "var(--color-grayscale-900)",
      }
    })
  }

  else if (color === "blue") {
    return css({
      color: "var(--color-blue-800)",

      "&:hover": {
        color: "var(--color-grayscale-900)",
      }
    })
  }

  else if (color === "pink") {
    return css({
      color: "var(--color-indigo-500)",

      "&:hover": {
        color: "var(--color-grayscale-900)",
      }
    })
  }
}

const size = ({ size }) => {
  if (size === 500) {
    return css({
      font:   "var(--text-740)",
      padding: "0 2px",
    })
  }
  else if (size === 400) {
    return css({
      font:   "var(--text-640)",
      padding: "0 2px",
    })
  }
  else if (size === 250) {
    return css({
      font:   "var(--text-340)",
      padding: "0 2px",

      "&:before": {
        height: 1,
        bottom: -1,
        left: 2,
        right: 2
      },
    })
  }
}

const common = () => css({
  display:        "inline-flex",
  textDecoration: "none",
  transition:     "color var(--fast-transition)",
  position:       "relative",

  "&:before": {
    content: "''",
    position: "absolute",
    transition: "background var(--fast-transition)",
    background: "currentColor",
    height: 2,
    bottom: -3,
    left: 3,
    right: 3
  },
})

export const Button = styled.button(common, color, size)
export const Link = styled(GatsbyLink)(common, color, size)
export const A = Button.withComponent("a")
